module.exports = __webpack_public_path__ + "static/media/chaimaa.05f22109.png";